/* eslint-disable import/prefer-default-export */
export const productList = [
  {
    name: 'komtim',
    desc: 'Tim E-commerce lengkap siap bantu kelola tokomu, mulai dari CS, admin marketplace, hingga tim live dan iklan',
    id: 1,
  },
  {
    name: 'komship',
    desc: 'Kirim paket COD & non-COD, cairkan dana instan, dan dapatkan diskon ongkir',
    id: 2,
  },
  {
    name: 'kompack',
    desc: 'Solusi pergudangan Jawa dan luar Jawa tanpa biaya sewa, dari penyimpanan s.d pengiriman',
    id: 3,
  },
  {
    name: 'komcard',
    desc: 'Buat kartu virtual tanpa batas untuk bayar iklan. Nikmati cashback dan bebas biaya admin',
    id: 4,
  },
  {
    name: 'komplace',
    desc: 'Satu dashboard untuk semua toko di marketplacemu, kelola pesanan, stok, dan chat pelanggan dari satu tempat',
    id: 6,
  },
  {
    name: 'komclass',
    desc: 'Kelas pelatihan digital untuk UMKM, Tingkatkan skill dan wawasan bisnismu lewat pelatihan praktis',
    id: 7,
  },
  {
    name: 'pumkm',
    desc: 'Terhubung dengan Pendamping UMKM di dekatmu. Dapatkan sesi mentoring 1 on 1 untuk mengembangkan bisnismu',
    id: 8,
  },
  {
    name: 'komads',
    desc: 'Layanan akun iklan whitelisted agar iklan Meta, Google, dan TikTok-mu berjalan lancar dan minim banned',
    id: 9,
  },
  {
    name: 'komchat',
    desc: 'Tools broadcast WhatsApp untuk kirim pesan massal, dilengkapi CS AI 24 jam siap jawab pertanyaan pelanggan',
    id: 10,
  },
  {
    name: 'komed',
    desc: 'Bikin video UGC dengan AI untuk kebutuhan iklan dan konten. Cepat, praktis, dan siap publish.',
    id: 11,
  },
]
